<template>
  <div v-if="talent != null" class="long-card" :class="visitedClass()" @click="onGoto">
    <a class="resume_seek_tag_big" v-if="cardType==1 && getSeekPeriod(talent.resumeRefreshTime)"></a>
    <el-container>
      <el-aside width="90px">
        <div style="position:relative;">
          <user-avatar :src="talent.headImage" class="cirle"></user-avatar>
        </div>
      </el-aside>
      <el-aside width="410px" class="info">
        <div><span class="name noborder" style="padding-right: 0;">{{ talent.fullName }}</span>
          <el-tooltip :content="'邀约面试赚'+interviewCoin+'乐币，录用赚'+hireCoin+'乐币'" placement="top" effect="dark">
            <el-tag v-if="talent.resumeType<3" effect="dark" type="success" size="mini">悬赏</el-tag>
          </el-tooltip>
          <el-tag v-if="talent.isRead && cardType!=2" type="info" size="mini">已读</el-tag>
          <el-tag v-if="talent.isDownload && cardType!=3" size="mini">已下载</el-tag>
          <el-tag v-if="talent.isInsteadInvite  && cardType!=4" type="success" size="mini">已代约</el-tag>
        </div>
        <div>
          <span>{{ talent.sex }}</span>
          <span>{{ talent.age }}岁</span>
          <span>工作{{ talent.workYear }}年</span>
          <span>{{ talent.degree }}</span>
          <span class="noborder">{{ talent.currentState }}</span>
        </div>
        <div>
          期望：<span v-if="talent.expectCity" v-html="highlightWord(talent.expectCity)"></span>
          <span v-if="talent.expectPost" v-html="highlightWord(talent.expectPost)"></span>
          <span class="noborder">{{ talent.expectMinSalary }}K-{{ talent.expectMaxSalary }}K</span>
        </div>
        <div class="exp">
          <span class="noborder" v-if="cardType==1">{{$Shared.formatDateTime3(talent.resumeRefreshTime)}} 更新</span>
          <span class="noborder" v-if="cardType==2">{{$Shared.formatDateTime3(talent.resumeReadTime)}} 看过</span>
          <span class="noborder" v-if="cardType==3">{{$Shared.formatDateTime3(talent.downloadTime)}} 下载</span>
          <span class="noborder" v-if="cardType==4">{{$Shared.formatDateTime3(talent.insteadInviteTime)}}
            发起代约&nbsp;&nbsp;职位：{{talent.insteadInvitePostName}}</span>
          <span class="noborder" v-if="cardType==5">{{$Shared.formatDateTime3(talent.recommendTime)}} <span v-if="talent.isSystem == 0">顾问「{{talent.gwName}}」</span><span v-else>由系统</span>推荐到职位：{{talent.coPostName}}</span>
        </div>
      </el-aside>
      <el-main style="width:536px">
        <div class="express">
          <div class="rela">
            <div v-if="talent.workList && talent.workList.length > 0" class="abs workiconSmall"></div>
            <el-row v-for="(work, index) in talent.workList" :key="index">
              <el-col v-if="index < 2" :span="6" class="time">{{ work.beginDate | parseTime("{y}/{m}") }} -
                {{ $Shared.formatDateYearMonth(work.endDate) }}</el-col>
              <el-col v-if="index < 2" :span="18">
                <span v-html="highlightWord(work.companyName)"></span>
                <span v-html="highlightWord(work.workPosition)"></span></el-col>
            </el-row>
          </div>
          <div class="rela" style="margin-top: 10px;">
            <div v-if="talent.educationList && talent.educationList.length > 0" class="abs eduiconSmall"></div>
            <el-row v-for="(edu, index) in talent.educationList" :key="index">
              <el-col v-if="index < 2" :span="6" class="time">{{ edu.beginDate | parseTime("{y}/{m}") }} -
                {{ $Shared.formatDateYearMonth(edu.endDate) }}</el-col>
              <el-col v-if="index < 2" :span="18"><span v-if="edu.degreeId >= 4">{{edu.eduMode}}</span>
                <span v-html="highlightWord(edu.degreeName + ' ' + edu.school + ' ' + edu.major)"></span></el-col>
            </el-row>
          </div>
        </div>
      </el-main>
      <el-main v-if="cardType == 4" style="cursor: default;" @click.native.stop="doNothing">
        <el-badge v-if="talent.lastGwServiceTime>talent.lastHrViewTime" value="新反馈" class="item">
          <el-button size="mini" type="primary" @click.stop="onViewInfo(talent)">查看代约</el-button>
        </el-badge>
        <el-button v-else size="mini" type="primary" @click.stop="onViewInfo(talent)">查看代约</el-button>
      </el-main>
      <el-main v-else-if="cardType != 5" style="text-align: right; cursor: default;" @click.native.stop="doNothing">
        <el-row v-if="talent.resumeType<3">
          <el-button type="primary" size="mini" @click.stop="onChat">立即沟通</el-button>
        </el-row>
        <el-row v-else>
          <el-button type="success" style="width: 80px" size="mini" @click.stop="onInsteadInvite">帮我约
          </el-button>
        </el-row>
      </el-main>
    </el-container>
    <dlgInsteadInvite ref='dlgInsinv' @success="onIISuccess">
    </dlgInsteadInvite>
    <dlgInsteadInviteInfo ref="insinvInfo"></dlgInsteadInviteInfo>
  </div>
</template>

<script>
  import {
    parseTime,
    resumeType2Source
  } from '~/utils';
  import {
    highlightWord
  } from '~/api/common';
  import {
    getUserDataID
  } from '~/api/me';
  import {
    getMeRewardInfo,
    insteadInviteInfo
  } from '~/api/insteadInvite';
  import userAvatar from '~/components/UserAvatar';
  import dlgInsteadInvite from './dlg_insteadInvite';
  import dlgInsteadInviteInfo from './myInsteadInvite/dlg_insteadInviteInfo';
  export default {
    props: {
      talent: {
        type: Object,
        default: null,
      },
      words: {
        type: Array,
        default: [],
      },
      cardType: {
        type: Number,
        default: 1
      }
    },
    components: {
      userAvatar,
      dlgInsteadInvite,
      dlgInsteadInviteInfo
    },
    data() {
      return {
        interviewCoin: 0,
        hireCoin: 0,
        happyRice: 0,
      };
    },
    filters: {
      parseTime(time, cformat) {
        var date = new Date(time);
        return parseTime(date, cformat);
      },
    },
    created() {
      this.getRewardInfo();
    },
    methods: {
      highlightWord(text) {
        if (text && text.length > 0 && this.words && this.words.length > 0) {
          return highlightWord(text, this.words);
        }
        return text;
      },
      getRewardInfo() {
        if (this.talent.resumeType < 3) {
          getMeRewardInfo({
            meDataId: this.$props.talent.resumeId
          }).then(r => {
            if (r.errcode === 0) {
              this.interviewCoin = r.data.interviewCoin;
              this.hireCoin = r.data.hireCoin;
            }
          });
        }
      },
      onGoto() {
        this.$store.commit('addSearchVisitedResumeList', {
          resumeType: this.talent.resumeType,
          resumeId: this.talent.resumeId
        });
        this.$emit('goto');
      },
      onChat() {
        var params = {
          meDataId: this.talent.resumeId
        };
        getUserDataID(params).then(r => {
          if (r.errcode === 0) {
            var userDataId = r.data;
            if (userDataId) {
              this.$router.push({
                path: 'HrChat',
                query: {
                  userid: userDataId
                }
              });
            }
          }
        });
      },
      onInsteadInvite() {
        let data = {
          fullName: this.talent.fullName,
          headImage: this.talent.headImage,
          resumeSource: resumeType2Source(this.talent.resumeType),
          resumeId: this.talent.resumeId
        };
        this.$refs['dlgInsinv'].show(data);
      },
      onIISuccess() {
        this.talent.isInsteadInvite = true;
      },
      onViewInfo(row) {
        insteadInviteInfo({
          insteadInviteId: row.insteadInviteId
        }).then(r => {
          if (r.errcode === 0) {
            this.$refs['insinvInfo'].show(row, r.data);
            this.talent.lastHrViewTime = this.talent.lastGwServiceTime; //取消有新的反馈标志
          } else {
            this.$message.error('获取代约详情出错！原因：' + r.errmsg);
          }
        });
      },
      getSeekPeriod() {
        var now = new Date();
        var seekTime = new Date(this.talent.resumeRefreshTime);
        var days = parseInt(Math.abs(now - seekTime) / 1000 / 60 / 60 / 24);
        if (days <= 14) return true;
        return false;
      },
      visitedClass() {
        var visitedList = this.$store.state.talent.searchVisitedResumeList;
        var index = visitedList.findIndex(i => i.resumeType == this.talent.resumeType && i.resumeId == this.talent
          .resumeId);
        if (index >= 0) {
          return 'visited';
        } else {
          return '';
        }
      },
      doNothing() {},
      isFirstRecommend(item) {
        return ((new Date() - new Date(item.joinTime)) < 31 * 24 * 3600 * 1000) && (item.viewCode == 'B' || item
          .viewCode == 'J');
      }
    },
  };
</script>

<style lang="scss">

</style>